import React from 'react';
import './Approach.css';

const steps = [
  {
    number: "01",
    title: "Discovery & Audit",
    description: "We dive deep into your business, competitors, and target audience to identify high-growth opportunities.",
    image: "/images/Audit.jpg"
  },
  {
    number: "02",
    title: "Strategic Roadmap",
    description: "Creating a data-driven digital strategy that aligns your brand with the right platforms and messaging.",
    image: "/images/strategy.jpg"
  },
  {
    number: "03",
    title: "Precision Execution",
    description: "Launching high-performance campaigns across SEO, PPC, and Social with clinical precision.",
    image: "/images/Precision.jpg"
  },
  {
    number: "04",
    title: "Scaling & ROI",
    description: "Continuous monitoring and optimization to ensure every dollar spent translates into measurable business growth.",
    image: "/images/roi.jpg"
  }
];

const Approach = () => {
  return (
    <section className="approach" id="approach">
      <div className="approach-container">
        <div className="approach-header" data-aos="fade-up">
          <span className="accent-tag">Our Methodology</span>
          <h2>A Strategic Approach to <span className="highlight">Digital Dominance</span></h2>
          <p>We combine data-driven insights with creative excellence to deliver results that actually matter.</p>
        </div>

        <div className="approach-grid">
          {steps.map((step, index) => (
            <div
              className="approach-card"
              key={index}
              data-aos="fade-up"
              data-aos-delay={index * 150}
            >
              <div className="card-top">
                <span className="step-number">{step.number}</span>
                <div className="step-image-container">
                  <img src={step.image} alt={step.title} className="step-image" />
                </div>
              </div>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
              <div className="card-decoration"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Approach;
